import { LogoIcon } from '@/components/icons'
import { TextRow } from './elements'

const AgreementText = () => {
  return (
    <>
      <LogoIcon />
      <TextRow>
        <p>
          <strong>Rent Collection Services Agreement</strong>
        </p>
      </TextRow>
      <TextRow>
        <ul>
          <li>
            You authorize liv.rent to make automatic deposits, less any applicable fees, into the
            bank account stated on your direct deposit enrollment form.
          </li>
          <li>
            You will promptly reimburse liv.rent for any overpayments or payments received by you in
            error.
          </li>
          <li>
            liv.rent will not be responsible for incomplete, late, or missed payments caused by:
            <ol type="i">
              <li>a Tenant’s failure to pay (in part or in full);</li>
              <li>
                by incorrect, incomplete, or outdated banking information provided by you, your
                representative, or your financial institution;
              </li>
              <li>
                by any error or delay of your financial institution depositing funds to your bank
                account; or
              </li>
              <li>
                by technical issues, outages, or delays caused or experienced by any financial
                institution or payment processor.
              </li>
            </ol>
          </li>
          <li>
            You are responsible for maintaining the accuracy and completeness of your banking
            information on liv.rent. If there are any changes to your banking information, you will
            accordingly update your banking information prior to the payment date for any direct
            deposits to you. You can make these changes from Payment Settings or contact
            support@liv.rent for assistance.
          </li>
          <li>
            liv.rent is not responsible for any refunds or disputes between you and any other user
            of the services, including Landlords and Tenants.
          </li>
          <li>
            This direct deposit agreement will remain effective until the earlier of:
            <ol type="i">
              <li>
                liv.rent receiving an emailed cancellation notice from you at support@liv.rent;
              </li>
              <li>you entering into a new direct deposit agreement with liv.rent;</li>
              <li>liv.rent receiving notice of cancellation from your financial institution; or</li>
              <li>
                liv.rent providing you with a cancellation notice either via email or through the
                liv.rent platform.
              </li>
            </ol>
          </li>
          <li>
            Deposit instructions may be changed via your Payment Settings or by contacting Liv
            Support at support@liv.rent
          </li>
        </ul>
      </TextRow>
    </>
  )
}

export default AgreementText
